import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import React from 'react';

/**
 * @param {import('@material-ui/core').CheckboxProps} props
 */
export default function CheckboxFilter({label, ...props}) {
  return (
    <FormControlLabel
      label={label}
      control={
        <Checkbox
          color="primary"
          {...props}
        />
      }
    />
  )
}